import { Flex } from 'front-commons/ds';
import { Typography } from 'hype-ds';
import { OpenInfoBoniModalProps } from './interfaces';

export const openInfoBoniModal = ({
	level,
	isMobile,
	levelName,
	levelConfig,
	handleOpenDialog,
	cashbackPercentage,
}: OpenInfoBoniModalProps) => {
	const levelInfo = (
		<Flex as="span" gap="2px" alignItems="center" display="inline-flex">
			<Typography.Label.M color={levelConfig.color}>Nível {levelName}</Typography.Label.M>

			<img src={levelConfig.icon} alt={`Nível ${levelName}`} width="20px" />
		</Flex>
	);

	return handleOpenDialog({
		heading: { title: 'Pontos Boni', showCloseButton: true },
		content: {
			description: (
				<Flex direction="column" gap="16px">
					<Typography.Paragraph.M>
						No Programa de Fidelidade Boni, os pontos são creditados após o faturamento do pedido e podem variar
						conforme a quantidade faturada.
					</Typography.Paragraph.M>

					<Typography.Paragraph.M whiteSpace="pre-line">
						Você está no {levelInfo} {isMobile && '\n'}e ganha
						{levelName === 'Comprimido' ? (
							<>
								<Typography.Label.M color="--text-primary"> 100 pontos</Typography.Label.M> na primeira compra{' '}
								{!isMobile && '\n'}
								faturada no Boni{' '}
								<Typography.Label.M color="--text-primary">
									+ {cashbackPercentage}% de cashback em pontos!
								</Typography.Label.M>
							</>
						) : (
							<Typography.Label.M color="--text-primary">
								{' '}
								{cashbackPercentage}% de cashback em pontos!
							</Typography.Label.M>
						)}
					</Typography.Paragraph.M>
				</Flex>
			),
		},
		footer: {
			primaryButton: { label: 'Entendi', width: { small: '100%', medium: '80px' } },
		},
	});
};
